/* ==========================================================================
   Workshop sticky bar — shared behaviour
   --------------------------------------------------------------------------
   Loaded by snippets/wsp-sticky-bar-actions.liquid, which the five workshop
   heroes render inside their sticky bar. Two jobs:

   1. The bar's buttons ("See dates", "Book now") open the booking widget's
      pop-up instead of scrolling back up to the card. Every booking widget
      (mosaic, pop-up, ceramic, coffee, ebru) keeps itself on its root element
      and has openModal(). With no such widget — the BookThatApp fallback, the
      pop-up turned off, or availability still loading — the button stays a
      plain #booking link.

   2. Zapier's chat button (layout/theme.liquid) is an iframe fixed to the
      bottom-right corner inside the component's shadow root, a layer under
      the bar, so the bar covered it. The page cannot style that iframe, but
      the component copies its style-override attribute onto it as an inline
      style, so that is how it gets lifted. The bar already tracks the booking
      card (it hides while the card is on screen), so its state drives the
      chat button too:
        bar shown           the chat button sits just above it
        bar hidden          the booking card is on screen: chat button hidden
        booking pop-up open chat button hidden
        chat open           nothing moves or hides it; the bar steps aside
      The component reports open and closed with window messages
      (zChatbotOpened / zChatbotClosed), which are read here too.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__wspStickyBar) return;
  window.__wspStickyBar = true;

  var ROOTS = '[data-mas-booking], [data-popup-booking], [data-ceramic-booking], [data-coffee-booking], [data-ebru-booking]';
  var KEYS = ['__masBooking', '__popupBooking', '__ceramicBooking', '__coffeeBooking', '__ebruBooking'];

  // Same funnel as the booking widgets: dataLayer, and Clarity as mas_<name>.
  function track(evt, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: evt };
      if (data) for (var k in data) payload[k] = data[k];
      window.dataLayer.push(payload);
    } catch (e) { /* analytics must never break booking */ }
    try {
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      window.clarity('event', 'mas_' + evt);
    } catch (e) { /* analytics must never break booking */ }
  }

  function bookingWidget() {
    var roots = document.querySelectorAll(ROOTS);
    for (var i = 0; i < roots.length; i++) {
      for (var j = 0; j < KEYS.length; j++) if (roots[i][KEYS[j]]) return roots[i][KEYS[j]];
    }
    return null;
  }

  /* ---------- 1. the buttons open the pop-up ---------------------------- */

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('[data-wsp-open-booking]') : null;
    if (!link) return;
    var w = bookingWidget();
    var canOpen = !!(w && w.booted && w.cfg && w.cfg.popup !== false && typeof w.openModal === 'function');
    track('sticky_bar_tapped', { button: link.getAttribute('data-wsp-open-booking'), opened_popup: canOpen });
    if (!canOpen) return;                    // the #booking link scrolls to the card
    e.preventDefault();
    w.openModal();
  });

  /* ---------- 2. the chat button ---------------------------------------- */

  function initChat() {
    var bar = document.querySelector('[data-wsp-mobilebar]');
    var chat = document.querySelector('zapier-interfaces-chatbot-embed');
    if (!bar || !chat) return;
    var html = document.documentElement, chatOpen = false;

    var update = function () {
      var shown = bar.classList.contains('is-shown');
      var bookingOpen = html.classList.contains('masbk-lock');
      html.classList.toggle('wsp-chat-open', chatOpen);
      html.classList.toggle('wsp-chat-away', !chatOpen && (!shown || bookingOpen));
      // offsetHeight is 0 where the bar is display:none (desktop on most of
      // the heroes), so the chat button stays in its corner there.
      var lift = !chatOpen && shown ? bar.offsetHeight : 0;
      var want = lift ? 'bottom: ' + lift + 'px' : '';
      if ((chat.getAttribute('style-override') || '') === want) return;
      if (want) chat.setAttribute('style-override', want);
      else chat.removeAttribute('style-override');
    };

    if (window.MutationObserver) {
      // The hero's observer toggles is-shown; the booking widgets put
      // masbk-lock on <html> while their pop-up is open.
      new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(update).observe(html, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', update);
    window.addEventListener('message', function (e) {
      if (e.data !== 'zChatbotOpened' && e.data !== 'zChatbotClosed') return;
      var frame = chat.shadowRoot && chat.shadowRoot.querySelector('iframe');
      if (frame && e.source !== frame.contentWindow) return;
      chatOpen = e.data === 'zChatbotOpened';
      update();
    });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initChat);
  else initChat();
})();
